<template>
  <cargo-dialog
    ref="cargoDialog"
    :visible="innerVisible"
    :title="$t('FinanceManage.AccountingVoucher')"
    width="1020px"
    :close-on-click-modal="false"
    :show-close="false"
    :can-minimize="true"
    :only-can-minimize="true"
    custom-class="accounting-entry-window"
    @close="cancelHandler"
  >
    <div class="header">
      <div class="left">
        <div>
          <span>{{ $t('CargoMsg.Cargo_VoucherLetter') }}</span>
          <span v-if="isExt&&isEdit">
            <el-select v-model="accountingDocument.prefix" no="1" style="width: 100px">
              <el-option
                v-for="item in prefixDataProvider"
                :key="item.uuid"
                :label="$store.getters.language === 'zh'?item.prefix:item.prefix"
                :value="item.prefix"
              />
            </el-select>
          </span>
          <span v-else style="font-weight: bold;">{{ accountingDocument.prefix }}</span>
        </div>
        <div style="margin-top: 5px;">
          <span>{{ $t('CargoMsg.Cargo_VoucherNo') }}</span>
          <span v-if="isExt&&isEdit">
            <el-input v-model="accountingDocument.documentNo" no="2" style="width: 100px" />
          </span>
          <span v-else>
            <el-select v-model="curIndex" no="3" style="width: 100px">
              <el-option v-for="(item, index) in voucher" :key="index" :value="index" :label="item.documentNo" />
            </el-select>
          </span>
        </div>
      </div>
      <div class="center">
        <h1>
          {{ $t('CargoMsg.Cargo_BookKeepingVoucher') }}
        </h1>
        <div style="margin-top: 10px;">
          <span>{{ $t('CargoMsg.Cargo_ProofDateP') }}</span>
          <el-date-picker
            v-if="isExt&&isEdit"
            v-model="accountingDocument.documentDate"
            no="4"
            type="date"
            style="width:100px;"
            value-format="yyyy-MM-dd"
            :editable="false"
            :clearable="false"
          />
          <span v-else>{{ documentDate }}</span>
        </div>
      </div>
      <div class="right">
        <div style="display: flex; justify-content: flex-end;">
          <span v-show="!isEdit" style="text-align: right; margin-left: 30px; margin-top: 5px;">{{ $t('CargoMsg.Cargo_OppositeVoucherNoP') }}</span>
          <el-input v-show="!isEdit" v-model="accountingDocument.targetDocumentNo" :disabled="true" no="5" style="margin-right: 5px;width: 100px;" />
          <el-button v-show="!preview" type="primary" :disabled="isEdit" no="6" @click="editTargetDocumentNoClickHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
        </div>
        <div style="text-align: right;margin-top: 10px;">
          <span>{{ $t('CargoMsg.Cargo_Attachment') }}</span>
          <el-input v-if="isExt&&isEdit" v-model="accountingDocument.sourceDocument" :disabled="!isExt || !isEdit" no="7" style="width: 65px" />
          <span v-else>{{ accountingDocument.sourceDocument }}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="accountingEntryRowData"
        :show-side-bar="false"
        min-height="260px"
      />
      <div class="app-main-inner-row">
        <div style="width: 100%;" />
        <div class="inner-row-border-bottom" style="width: 360px; display:flex; justify-content: flex-start; text-align: right;margin-top: 0px;">
          <div style="width: 50px;"><span style="font-size: 13px;"> {{ $t('CargoMsg.Cargo_GrandTotal') }} </span></div>
          <div style="width: 120px;"><span style="font-size: 13px;"> {{ debitTotal }} </span></div>
          <div style="width: 120px;"><span style="font-size: 13px;"> {{ creditTotal }}</span></div>
        </div>
      </div>
      <fieldset>
        <legend>{{ $t('CargoMsg.Cargo_SubsidiaryAccountingItems') }}</legend>
        <el-form label-width="80px" :disabled="!isExt || !isEdit">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Customer')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  no="8"
                  :default-value="txtCustomerExt"
                  :method-params="{}"
                  :placeholder="' '"
                  @parentCallBack="customerExtChangeHandler"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Vendor')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  no="9"
                  :default-value="txtCustomerExt2"
                  :method-params="{}"
                  :placeholder="' '"
                  @parentCallBack="customerExtChangeHandler"
                /></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Staff')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_MappingStaff"
                  filterable
                  no="10"
                  :cache="false"
                  :default-value="curRowData.staffId"
                  :placeholder="' '"
                  :static-options="mappingStaffs"
                  @parentCallBack="staffChangeHandler"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Department')">
                <cargo-advance-select
                  :select-type="selectTypeNames.static_data_MappingDepartment"
                  filterable
                  no="11"
                  :cache="false"
                  :default-value="curRowData.department"
                  :placeholder="' '"
                  :static-options="mappingDepartments"
                  :custom-label="departmentLabelFun"
                  @parentCallBack="department => curRowData.department = department.departmentId"
                />
              </el-form-item></el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Salesman')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_User"
                  filterable
                  no="12"
                  :default-value="curRowData.sales"
                  :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'sales'}"
                  :placeholder="' '"
                  @parentCallBack="saleChangeHandler"
                /></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_ItemNoP')"><el-input v-model="curRowData.projectNumber" no="13" /></el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_ItemNo2P')"><el-input v-model="curRowData.projectNumber2" no="14" /></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_BusinessHappenDateP')" label-width="90px">
                <el-date-picker
                  v-model="curRowData.businessDate"
                  no="15"
                  type="date"
                  style="width:135px;"
                  value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </fieldset>
    </div>
    <div slot="footer" class="footer">
      <div>
        <el-button v-show="!preview && !isEdit" type="primary" no="16" style="width: 70px;" @click="handleMoveIndex('first')">{{ $t('CargoMsg.Cargo_1St') }}</el-button>
        <el-button v-show="!preview && !isEdit" type="primary" no="17" style="width: 70px; margin-left: 5px;" @click="handleMoveIndex('pre')">{{ $t('CargoMsg.Cargo_TheLastPage') }}</el-button>
        <el-button v-show="!preview && !isEdit" type="primary" no="18" style="width: 70px; margin-left: 5px;" @click="handleMoveIndex('next')">{{ $t('CargoMsg.Cargo_TheNextPage') }}</el-button>
        <el-button v-show="!preview && !isEdit" type="primary" no="19" style="width: 70px; margin-left: 5px;" @click="handleMoveIndex('last')">{{ $t('CargoMsg.Cargo_TheLast') }}</el-button>
        <span style="margin-left: 40px;">{{ `${ $t('CargoMsg.Cargo_PreparedBy')}` }}</span><span style="font-weight: bold;margin-left: 10px;">{{ `${ documentMaker }` }}</span>
        <span style="margin-left: 30px;">{{ `${ $t('CargoMsg.Cargo_Auditor')}` }}</span><span style="font-weight: bold;margin-left: 10px;">{{ `${ verifier }` }}</span>
      </div>
      <div>
        <el-button v-if="!preview && isExt && isEdit" type="primary" no="20" @click="checkLossClickHandler">{{ $t('CargoMsg.Cargo_BrokenNumberDetection') }}</el-button>
        <el-button v-if="!preview && isExt && isEdit" type="primary" no="21" style="width: 70px; margin-left: 5px;" @click="addEntryClickHandler">{{ $t('CargoMsg.Cargo_AddJournalEntry') }}</el-button>
        <el-button v-if="!preview && isExt && isEdit" type="primary" no="22" style="width: 70px; margin-left: 5px;" :disabled="!hasSelected" @click="removeEntryClickHandler">{{ $t('CargoMsg.Cargo_DeleteEntry') }}</el-button>
        <el-button v-if="auditBtnVisible && !isEdit" type="primary" no="23" style="width: 70px; margin-left: 5px;" @click="auditHandler">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
        <el-button v-if="auditBtnVisible" type="primary" no="24" style="width: 70px; margin-left: 5px;" @click="btnEditClick">{{ isEdit ? $t('CargoMsg.Cargo_Save') : $t('CargoMsg.Cargo_Edit') }}</el-button>
        <el-button no="25" style="width: 70px; margin-left: 5px;" @click="cancelHandler">{{ isEdit ? $t('CargoMsg.Cargo_Cancel') : $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </div>
    <!-- 费用详情 -->
    <account-entry-charge-detail-window
      ref="accountingEntryCharge"
      :visible.sync="accountingEntryChargeDetailWindow.visible"
      @close="closeChargeDetailWindow"
    />

  </cargo-dialog>
</template>

<script>
import * as NumberUtils from '@/utils/NumberUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import CargoDepartmentSelectByOfficeId from '@/components/Cargo/Common/cargoDepartmentSelectByOfficeId'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { detail, updateTargetDocumentNo, verify, checkLossDocumentNo, save, updateAccountingDocument } from '@/api/financeManage/accountingDocument'
import StrUtils from '@/utils/StrUtils'
import { formatNumberToThousands } from '@/utils'
import BigNumber from 'bignumber.js'
import moment from 'moment'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as AccountTitleType from '@/class/cargo/model/parameters/AccountTitleType'
import accountEntryChargeDetailWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/AccountEntryChargeDetailWindow'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'AccountingEntryWindow',
  components: { CargoDialog, CargoDepartmentSelectByOfficeId, CargoAdvanceSelect, accountEntryChargeDetailWindow },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    isExt: {
      type: Boolean,
      default: () => false
    },
    prefixDataProvider: {
      type: Array,
      default: () => []
    },
    accountTitleDataProvider: {
      type: Array,
      default: () => []
    },
    voucher: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: () => 0
    },
    accountSet: { type: Object }, // 账套
    mappingDepartments: { type: Array, default: () => [] }, // 部门
    mappingStaffs: { type: Array, default: () => [] }, // 职员
    check: { type: Boolean, default: () => false },
    checkDepartment: { type: Boolean, default: () => false },
    preview: { type: Boolean, default: () => false } // 预览凭证
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      voucherSetCustomerOrSupplier: 0, // 控制凭证分录的结算对象辅助核算项生成位置。0=客户/供应商区分 1=都生成在客户 2=都生成供应商
      accountTitleDataProviderDirty: true,
      multiAccountSet: false,
      prefixDictionary: [],
      curIndex: this.index,
      isEdit: false,
      gridOptions: {
        singleClickEdit: true,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        }
      },
      accountingDocument: {
      },
      accountingEntryChargeDetailWindow: {
        visible: false
      },
      curRowData: {},
      curRowIndex: -1,
      rowData: [],
      totalDebit: 0,
      totalCredit: 0
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    columnDefs() {
      const { isExt, isEdit } = this
      const self = this
      return [
        {
          field: 'sequenceNumber',
          tooltipField: 'sequenceNumber',
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          editable: false,
          width: 80
        },
        {
          field: 'summary',
          tooltipField: 'summary',
          headerName: this.$t('CargoMsg.Cargo_Abstract'),
          editable: isEdit, width: 190
        },
        {
          field: 'accountTitle',
          headerName: this.$t('CargoMsg.Cargo_AccountTitleCode'),
          editable: isExt && isEdit, width: 100,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              clearable: false,
              tagValue: 'accountTitle',
              tagName: 'accountTitle',
              filterType: 'global',
              staticOptions: this.accountTitleDataProvider,
              filterTagNames: ['accountTitle', 'accountTitleName'],
              customLabel: (item) => `[${item.accountTitle}]${item.accountTitleName}`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          field: 'accountTitleName',
          headerName: this.$t('CargoMsg.Cargo_AccountTitleName'), width: 130
        },
        {
          field: 'sourceCurrency',
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          valueFormatter: () => {},
          editable: isEdit, width: 80,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              clearable: false,
              tagValue: 'code',
              tagName: 'code',
              selectType: TYPE_NAMES.basic_data_Currency,
              callbackParams: { key: 'currency' },
              callbackMethodType: 'value'
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data ? params.data.sourceCurrency : ''
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          field: 'sourceAmount',
          headerName: this.$t('CargoMsg.Cargo_Amount'),
          valueFormatter: function(params) {
            const value = self.numberLabelFunc(params)
            return StrUtils.isEmpty(value) ? value : NumberUtils.formatNumber(Math.abs(value), 2)
          },
          cellRenderer: (params) => {
            const value = self.numberLabelFunc(params)
            return StrUtils.isEmpty(value) ? value : formatNumberToThousands(NumberUtils.formatNumber(Math.abs(value), 2), 2)
          },
          editable: isEdit, width: 100,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          cellStyle: function(params) {
            if (params.data.sourceAmount < 0) {
              return { textAlign: 'right', color: 'red' }
            } else {
              return { textAlign: 'right', color: 'black' }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          field: 'exchangeRate',
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate'),
          valueFormatter: this.numberLabelFunc,
          editable: isEdit, width: 80,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          cellStyle: { textAlign: 'right' },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          field: 'debit',
          headerName: this.$t('CargoMsg.Cargo_DebitLocalCurrency'),
          valueFormatter: function(params) {
            const value = isExt ? self.amountLabelFunction2(params) : self.amountLabelFunction(params)
            return StrUtils.isEmpty(value) ? value : NumberUtils.formatNumber(Math.abs(value), 2)
          },
          cellRenderer: (params) => {
            const value = isExt ? self.amountLabelFunction2(params) : self.amountLabelFunction(params)
            return StrUtils.isEmpty(value) ? value : formatNumberToThousands(NumberUtils.formatNumber(Math.abs(value), 2), 2)
          },
          editable: isExt && isEdit, width: 115,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: params => {
            return {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              },
              value: params.data.amount
            }
          },
          cellStyle: function(params) {
            if (params.data.sourceAmount < 0) {
              return { textAlign: 'right', color: 'red' }
            } else {
              return { textAlign: 'right', color: 'black' }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          field: 'credit',
          headerName: this.$t('CargoMsg.Cargo_CreditLocalCurrency'),
          valueFormatter: function(params) {
            const value = isExt ? self.amountLabelFunction3(params) : self.amountLabelFunction(params)
            return StrUtils.isEmpty(value) ? value : NumberUtils.formatNumber(Math.abs(value), 2)
          },
          cellRenderer: (params) => {
            const value = isExt ? self.amountLabelFunction3(params) : self.amountLabelFunction(params)
            return StrUtils.isEmpty(value) ? value : formatNumberToThousands(NumberUtils.formatNumber(Math.abs(value), 2), 2)
          },
          editable: isExt && isEdit, width: 115,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: params => {
            return {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              },
              value: params.data.amount
            }
          },
          cellStyle: function(params) {
            if (params.data.sourceAmount < 0) {
              return { textAlign: 'right', color: 'red' }
            } else {
              return { textAlign: 'right', color: 'black' }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
    },
    auditBtnVisible() {
      const { accountingDocument } = this
      return accountingDocument && accountingDocument.state === 0 && !this.checkVoucherDateClosing(accountingDocument.documentDate, this.accountSet)
    },
    hasSelected() {
      return Object.keys(this.curRowData).length
    },
    documentDate() {
      return ColumnUtils.dateLabelFunc(this.accountingDocument.documentDate)
    },
    documentMaker() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.accountingDocument.documentMaker, 'chineseName')
    },
    verifier() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.accountingDocument.verifier, 'chineseName')
    },
    debitTotal() {
      return formatNumberToThousands(NumberUtils.ToFixed2(this.accountingDocument.debitTotal, 2), 2)
    },
    creditTotal() {
      return formatNumberToThousands(NumberUtils.ToFixed2(this.accountingDocument.creditTotal, 2), 2)
    },
    isAr() {
      return FinanceInterfaceConstants.isArEntry(this.curRowData.entryType, this.accountingDocument.businessDataType)
    },
    txtCustomerExt() {
      if (this.voucherSetCustomerOrSupplier === 1) {
        return this.curRowData.accountClient
      }
      if (this.voucherSetCustomerOrSupplier === 2) {
        return 0
      }
      return this.isAr ? this.curRowData.accountClient : 0
    },
    txtCustomerExt2() {
      if (this.voucherSetCustomerOrSupplier === 1) {
        return 0
      }
      if (this.voucherSetCustomerOrSupplier === 2) {
        return this.curRowData.accountClient
      }
      return this.isAr ? 0 : this.curRowData.accountClient
    },
    btnEditLabel() {
      return this.isEdit ? this.$t('CargoMsg.Cargo_Save') : this.$t('CargoMsg.Cargo_Edit')
    },
    accountingEntryRowData() {
      if (this.accountingDocument && this.accountingDocument.accountingEntry && this.accountingDocument.accountingEntry.length > 0) {
        this.accountingDocument.accountingEntry.forEach((item, index) => {
          item.sequenceNumber = index + 1 // 序号从1开始
        })
        return this.accountingDocument.accountingEntry
      }
      return this.rowData
    }
  },
  watch: {
    curIndex(newVal, oldVal) {
      console.log('curIndex', newVal, oldVal)
      if (newVal !== oldVal) {
        this.indexChanged()
      }
    }
  },
  mounted() {
    this.indexChanged()
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.voucherSetCustomerOrSupplier = parseInt(cache.config.get('VoucherSetCustomerOrSupplier'))
    },
    indexChanged() {
      this.init()
      if (this.curIndex < 0 || this.curIndex >= this.voucher.length) return
      const selectedRow = this.voucher[this.curIndex]
      const requestBody = { accountingSetKey: this.accountSet.uuid, uuid: selectedRow.uuid }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      detail(requestBody).then(res => {
        this.accountingDocument = res.data
        this.curRowIndex = this.accountingEntryRowData.length === 0 ? -1 : 0
        this.curRowData = this.accountingEntryRowData.length === 0 ? {} : this.accountingEntryRowData[0]
        this.gridOptions.api.setFocusedCell(0, 'summary')
        // this.gridOptions.api.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    numberLabelFunc(params) {
      let precision = 2
      if (params.colDef.field === 'sourceAmount') { precision = 2 } else if (params.colDef.field === 'exchangeRate') { precision = 8 }
      return NumberUtils.formatRoundNumber(params.value, precision)
    },
    amountLabelFunction(params) {
      const { data } = params
      if (data) {
        if ((data.debitCrebit && params.colDef.field === 'debit') || (!data.debitCrebit && params.colDef.field === 'credit')) {
          return NumberUtils.formatNumber(data.amount, 2)
        }
      }
      return ''
    },
    amountLabelFunction2(params) {
      const { data } = params
      if (data) {
        if (data.debitCrebit) {
          return NumberUtils.formatNumber(data.amount, 2)
        }
      }
      return ''
    },
    amountLabelFunction3(params) {
      const { data } = params
      if (!data.debitCrebit) {
        return NumberUtils.formatNumber(data.amount, 2)
      }
      return ''
    },
    checkVoucherDateClosing(voucherDate, accountSet) {
      voucherDate = moment(voucherDate)
      for (const fp of accountSet.fiscalPeriod) {
        if (fp.closing && fp.year === voucherDate.year() && fp.month === (voucherDate.month() + 1)) {
          return true
        }
      }
      return false
    },
    onRowClicked(params) {
      console.log('onRowClicked: ' + params)
      this.curRowIndex = params.rowIndex
      this.curRowData = params.data
    },
    handleMoveIndex(type) {
      if (this.voucher.length === 0) {
        return
      }
      switch (type) {
        case 'first':
          this.curIndex = 0
          break
        case 'pre':
          if (this.curIndex === 0) {
            this.curIndex = this.voucher.length - 1
          } else {
            this.curIndex--
          }
          break

        case 'next':
          if (this.curIndex === this.voucher.length - 1) {
            this.curIndex = 0
          } else {
            this.curIndex++
          }
          break

        case 'last':
          this.curIndex = this.voucher.length - 1
          break

        default:
          break
      }
    },
    checkLossClickHandler() {
      const { accountingDocument } = this
      const obj = {}
      obj.accountSetKey = this.accountSet.uuid
      obj.year = accountingDocument.year
      obj.month = accountingDocument.month
      obj.prefix = accountingDocument.prefix
      obj.entity = accountingDocument
      obj.currentDocNo = accountingDocument.documentNo
      // Todo Session.getInstance().callService
      // Session.getInstance().callService('AccountingDocumentService', 'checkLossDocumentNo', new mx.rpc.Responder(checkLossResultHandler, checkLossFaultHandler), obj)
      this.loading = getLoading()
      checkLossDocumentNo(this.accountingDocument).then(res => {
        if (res.data) {
          this.$message.warning(this.accountingDocument.year + '.' + this.accountingDocument.month + this.accountingDocument.prefix + this.$t('CargoMsg.Cargo_IsBroken'))
        } else {
          this.$message.info(this.accountingDocument.year + '.' + this.accountingDocument.month + this.accountingDocument.prefix + this.$t('CargoMsg.Cargo_NoNumberBreak'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addEntryClickHandler() {
      let last = null
      if (this.accountingDocument.accountingEntry && this.accountingDocument.accountingEntry.length > 0) {
        last = this.accountingDocument.accountingEntry[this.accountingDocument.accountingEntry.length - 1]
      }
      const entry = {}
      entry.sourceCurrency = this.accountSet.localCurrency
      entry.exchangeRate = 1
      entry.serialNumber = this.accountingDocument.accountingEntry ? this.accountingDocument.accountingEntry.length : 0
      entry.summary = last === null ? '' : last.summary
      entry.accountingDocumentUuid = this.accountingDocument.uuid
      entry.debitCrebit = false
      entry.accountTitle = ''
      entry.accountTitleName = ''
      entry.accountClient = 0
      entry.staffId = 0
      entry.department = 0
      entry.sales = 0
      entry.projectNumber = ''
      entry.projectNumber2 = ''
      entry.businessDate = null
      entry.businessDate2 = null
      entry.quantity = 0.0
      entry.amount = 0.0
      entry.sourceAmount = 0.0
      this.accountingDocument.accountingEntry.push(entry)
      this.curRowIndex = this.accountingDocument.accountingEntry.length - 1
      this.curRowData = this.accountingDocument.accountingEntry[this.curRowIndex]
      console.log('addEntryClickHandler', entry)
      this.$nextTick(() => {
        this.gridOptions.api.setFocusedCell(entry.serialNumber, 'summary')
      })
    },
    removeEntryClickHandler() {
      console.log('removeEntryClickHandler', this.curRowData)
      if (this.accountingDocument.accountingEntry && this.curRowData) {
        const index = this.accountingDocument.accountingEntry.indexOf(this.curRowData)
        this.accountingDocument.accountingEntry.splice(index, 1)
        this.curRowIndex = -1
        this.curRowData = {}
      }
      this.calculate()
    },
    calculate() {
      let debitTotal = 0
      let creditTotal = 0
      for (const item of this.accountingEntryRowData) {
        if (StrUtils.isEmpty(item.accountingDocumentUuid)) continue
        item.sourceAmount = NumberUtils.roundHalfUp2(item.sourceAmount)
        item.amount = NumberUtils.roundHalfUp2(item.sourceAmount * item.exchangeRate)
        if (item.debitCrebit) {
          debitTotal += NumberUtils.roundHalfUp2(item.amount)
        } else {
          creditTotal += NumberUtils.roundHalfUp2(item.amount)
        }
      }
      this.accountingDocument.debitTotal = debitTotal
      this.accountingDocument.creditTotal = creditTotal
      this.totalDebit = NumberUtils.formatNumber(debitTotal, 2)
      this.totalCredit = NumberUtils.formatNumber(creditTotal, 2)
    },
    auditHandler() {
      const { accountingDocument } = this
      accountingDocument.state = FinanceInterfaceConstants.VOUCHER_AUDITED.code
      accountingDocument.verifier = this.$store.getters.userId
      accountingDocument.verifyDate = new Date()
      // Todo save2
      // accountingDocument.save2(auditResultHandler, auditFaultHandler)
      const requestBody = { 'accountingKeys': [accountingDocument.uuid], 'state': FinanceInterfaceConstants.VOUCHER_AUDITED.code }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      verify(requestBody).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
        accountingDocument.version = this.accountingDocument.version + 1
        // 刷新
        this.$emit('updateAudit', accountingDocument)
      }).finally(() => {
        this.loading.close()
      })
    },
    btnEditClick() {
      if (this.isEdit) {
        this.saveHandler()
      } else {
        this.editHandler()
      }
    },
    saveHandler() {
      // CARGO-30956 修改凭证日期后，月份没有更新
      // 校验调整后的那个月份是否关账
      if (this.checkVoucherDateClosing(this.accountingDocument.documentDate, this.accountSet)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
        return
      }
      const voucherDate = moment(this.accountingDocument.documentDate)
      this.accountingDocument.year = voucherDate.year()
      this.accountingDocument.month = voucherDate.month() + 1
      if (this.check) {
        this.extCheck()
      } else {
        this.loading = getLoading()
        save(this.accountingDocument).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.accountingDocument = res.data
          this.isEdit = false
          // 刷新
          this.$emit('updateAudit', this.accountingDocument)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    editHandler() {
      this.isEdit = true
      // Todo
    },
    cancelHandler() {
      if (this.isEdit) {
        this.isEdit = false
        this.indexChanged()
      } else {
        this.innerVisible = false
        if (this.destroySelf) {
          this.destroySelf()
        }
      }
    },
    editTargetDocumentNoClickHandler() {
      this.$prompt(this.$t('CargoMsg.Cargo_EditOppositeVoucherNo'), this.$t('CargoMsg.Cargo_OppositeVoucherNoP'), {
        inputValue: this.accountingDocument.targetDocumentNo,
        confirmButtonText: this.$t('common.btn.save'),
        cancelButtonText: this.$t('common.btn.cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(({ value }) => {
        const requestBody = { uuid: this.accountingDocument.uuid, version: this.accountingDocument.version, targetDocumentNo: value }
        console.log('requestBody', requestBody)
        this.loading = getLoading()
        updateTargetDocumentNo(requestBody).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.accountingDocument.targetDocumentNo = res.data.targetDocumentNo
          this.accountingDocument.version = res.data.version
          // 刷新
          this.$emit('updateTargetDocumentNo', this.accountingDocument)
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    customerExtChangeHandler(company) {
      this.curRowData.accountClient = company.cmpIdx
    },
    departmentLabelFun(item) {
      if (item) {
        return '【' + item.financeCode + '】' + item.chineseName
      }
      return ''
    },
    saleChangeHandler(item) {
      this.curRowData.sales = item.userId
    },
    staffChangeHandler(item) {
      this.curRowData.staffId = item.staffId || 0
    },
    // 列数据改变
    onCellChange(params) {
      console.log('onCellChange', params)
      const { node, data } = params
      if (params.colDef.field === 'exchangeRate') {
        const exchangeRate = CurrencyUtil.truncateRateByCurrency(data.sourceCurrency, data.exchangeRate)
        if (exchangeRate !== data.exchangeRate) {
          node.setDataValue('exchangeRate', exchangeRate)
          return
        }
      }
      const item = params.data
      const field = params.colDef.field
      const value = params.newValue
      const originalValue = params.oldValue
      switch (field) {
        case 'accountTitle':
          this.accountTitleChangeHandler(item)
          break
        case 'sourceCurrency':
          this.currencyChangeHandler(item)
          break
        case 'sourceAmount':

          break
        case 'exchangeRate':

          break
        case 'debit':
          if (value > 0) item.debitCrebit = true
          break
        case 'credit':
          if (value > 0) item.debitCrebit = false
          break
        default:
      }
      this.$nextTick(() => {
        this.gridItemEditorSessionSaveHandler()
        this.gridOptions.api.refreshCells({ force: true })
      })
    },
    async currencyChangeHandler(entry) {
      if (entry.sourceCurrency === this.accountSet.localCurrency) {
        entry.exchangeRate = 1
      } else {
        entry.exchangeRate = await RateUtil.getForeignExchangeRateSafely(this.accountSet.localCurrency, entry.sourceCurrency, this.accountingDocument.documentDate, this.accountSet.branchId, 0, false)
        entry.exchangeRate = NumberUtils.roundHalfUp(entry.exchangeRate, 8)
      }
    },
    accountTitleChangeHandler(entry) {
      const accountTitle = this.findAccountTitle(entry.accountTitle)
      if (accountTitle && accountTitle.accountTitleName) {
        entry.accountTitleName = accountTitle.accountTitleName
      } else {
        entry.accountTitleName = ''
      }
    },
    gridItemEditorSessionSaveHandler() {
      this.calculate()
      const diff = this.calcAccountingEntryDiff(this.accountingDocument.accountingEntry)
      const diffEntry = this.createDiffEntry(diff)
      if (diffEntry && diffEntry.sourceCurrency) {
        this.accountingDocument.accountingEntry.push(diffEntry)
        this.calculate()
      }
    },
    extCheck() {
      if (!this.checkEntry()) return

      let pass = true
      for (const entry of this.accountingDocument.accountingEntry) {
        const accountTitle = this.findAccountTitle(entry.accountTitle)
        if (accountTitle) {
          if (!this.checkAccountingCurrency(entry, accountTitle)) {
            if (!accountTitle.accountingCurrency) { this.$message.warning(entry.accountTitle + this.$t('CargoMsg.Cargo_CFCNAPM').format(entry.sourceCurrency)) } else { this.$message.warning(entry.accountTitle + this.$t('CargoMsg.Cargo_TTOAFNTCCPM').format(accountTitle.sourceCurrency, entry.sourceCurrency)) }
            return
          }
          pass = this.validateAccountingEntry(entry, accountTitle)
          if (!pass) {
            return
          }
        }
      }
      this.saveDocument()
    },
    checkEntry() {
      const virtual = this.$t('CargoMsg.Cargo_Virtual')
      for (const entry of this.accountingDocument.accountingEntry) {
        if (StrUtils.isEmpty(entry.summary)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_IndexCanTBeEmpty'))
          return false
        }
        if (StrUtils.isEmpty(entry.accountTitle)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AccountTitleCodeCanTBeEmpty'))
          return false
        }
        if (StrUtils.isEmpty(entry.accountTitleName)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AccountTitleNameCanTBeEmpty'))
          return false
        }
        if (StrUtils.isEmpty(entry.sourceCurrency)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyCanTBeEmpty'))
          return false
        }
        if (entry.exchangeRate <= 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ExchangeRateCanTBeEmpty'))
          return false
        }
        if (entry.sourceAmount === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AmountCanTBeEmpty'))
          return false
        }
        if (entry.amount === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_DLCCLCCTBE'))
          return false
        }
        // CARGO-8216，增加校验损益类科目的部门为虚拟部门
        if (this.checkDepartment && entry.department > 0) {
          const accountTitle = this.findAccountTitle(entry.accountTitle)
          if (accountTitle && accountTitle.accountTitleType === AccountTitleType.INTEREST.code) {
            const chineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', entry.department, 'chineseName')
            if (!StrUtils.isEmpty(chineseName) && chineseName.indexOf(virtual) === -1) {
              this.$message.warning(this.$t('CargoMsg.Cargo_OVDCBUFPLAT'))
              return false
            }
          }
        }
      }
      return true
    },
    checkAccountingCurrency(entry, accountTitle) {
      if (!accountTitle.accountingCurrency) {
        return entry.sourceCurrency === this.accountSet.localCurrency
      } else {
        const currencyArray = accountTitle.sourceCurrency.split(',')
        if (currencyArray) {
          for (const currency of currencyArray) {
            if (currency === entry.sourceCurrency) return true
          }
        } else {
          return entry.sourceCurrency === 'USD'
        }
      }
      return false
    },
    validateAccountingEntry(entry, accountTitle) {
      const name = entry.accountTitle + '-' + entry.accountTitleName
      const isAr = FinanceInterfaceConstants.isArEntry(entry.entryType, this.accountingDocument.businessDataType)
      if ((accountTitle.auxiliaryCustomer || accountTitle.auxiliarySupplier) && entry.accountClient === 0) {
        const lb = isAr ? this.$t('CargoMsg.Cargo_Customer') : this.$t('CargoMsg.Cargo_Vendor')
        this.$message.warning(this.$t('CargoMsg.Cargo_PESAI').format(name, lb))
        return false
      } else if (accountTitle.auxiliaryProjectNumber && entry.projectNumber.trim().length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PESAIN').format(name))
        return false
      } else if (!this.isFinalStage(accountTitle)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotAFinalAccountTitle').format(name))
        return false
      }
      return true
    },
    findAccountTitle(accountTitle) {
      return accountTitle ? this.accountTitleDataProvider.find(title => title.accountTitle === accountTitle) : null
    },
    isFinalStage(accountTitle) {
      let isFinal = true
      for (const at of this.accountTitleDataProvider) {
        if (at && at.level > accountTitle.level && at.accountTitleType === accountTitle.accountTitleType) {
          let match = true
          for (let i = 1; i <= accountTitle.level; i++) {
            if (accountTitle['accountItem' + i] !== at['accountItem' + i]) {
              match = false
              break
            }
          }
          if (match) {
            isFinal = false
            break
          }
        }
      }
      return isFinal
    },
    saveDocument() {
      this.loading = getLoading()
      updateAccountingDocument(this.accountingDocument).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.accountingDocument = res.data
        this.isEdit = false
        // 刷新
        this.$emit('updateAudit', this.accountingDocument)
      }).finally(() => {
        this.loading.close()
      })
    },
    calcAccountingEntryDiff(entityList) {
      let debit = 0
      let crebit = 0
      for (const entry of entityList) {
        if (entry.debitCrebit) {
          debit += entry.amount
        } else {
          crebit += entry.amount
        }
      }
      return debit - crebit
    },
    createDiffEntry(diffAmount) {
      const entry = {}
      if (Math.abs(diffAmount) >= 0.005) {
        entry.sourceCurrency = this.accountSet.localCurrency
        entry.exchangeRate = 1
        entry.serialNumber = this.accountingDocument.accountingEntry ? this.accountingDocument.accountingEntry.length : 0
        entry.accountingDocumentUuid = this.accountingDocument.uuid
        entry.debitCrebit = diffAmount < 0
        entry.accountTitle = ''
        entry.accountTitleName = ''
        entry.accountClient = 0
        entry.staffId = 0
        entry.department = 0
        entry.sales = 0
        entry.projectNumber = ''
        entry.projectNumber2 = ''
        entry.businessDate = null
        entry.businessDate2 = null
        entry.quantity = 0.0
        entry.amount = NumberUtils.roundHalfUp(Math.abs(diffAmount), 2)
        entry.sourceAmount = NumberUtils.roundHalfUp(Math.abs(diffAmount), 2)
        entry.entryType = diffAmount < 0 ? FinanceInterfaceConstants.FINANCIAL_RECEIVABLE.code : FinanceInterfaceConstants.FINANCIAL_PAYABLE.code
        entry.summary = ''
      }
      return entry
    },
    // 双击分录
    onRowDoubleClicked(event) {
      if (this.isEdit) return
      const selectedItem = event.data
      if (!selectedItem) return
      this.$nextTick(() => {
        this.accountingEntryChargeDetailWindow.visible = true
        this.$refs.accountingEntryCharge.showDetail(selectedItem)
      })
    },
    // 关闭费用详情弹框
    closeChargeDetailWindow(flag) {
      this.accountingEntryChargeDetailWindow.visible = false
      if (flag) { // 这里将凭证详情弹框最小化
        this.$refs.cargoDialog.onModalMin()
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.accounting-entry-window{
  .header {
    display: flex;
    &>div {
      flex: 1;
      span {
        margin-right: 5px;
      }
      h1 {
        margin:0;
        font-weight: normal;
        color: #018080;
        text-decoration: underline solid;
      }
    }
    .center {
      text-align: center;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    fieldset {
      border-color: $--border-color-base;
      border-radius: $--border-radius-base;
      legend {
        padding: 10px;
      }
    }
  }
  .footer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .inner-row-border-bottom{
    margin-bottom: -10px;
    border-bottom: 1px solid gray;
  }
}
</style>
